module.exports = __webpack_public_path__ + "img/service_kyusyu_atm_network_sp.0a254585.svg";